import { useEffect, useRef } from "react";

const useJsonLd = (data) => {
  const dataRef = useRef(data);
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(dataRef.current);
    script.setAttribute("data-jsonld", "true");
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);
};

export default useJsonLd;
